module.exports = __webpack_public_path__ + "static/media/get-certified.f6c952af.png";